import Link from "next/link";

import { routes } from "src/shared/routes";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

export const FAQS: TTeamConfig["LANGUAGES"]["FAQS"] = [
  {
    question: "How do I claim my tickets?",
    answer:
      "You will receive a text when the window to check-in is opened. The check-in window opens the week of the game.",
  },
  {
    question: "Do I get a ticket to each game on the schedule?",
    answer:
      "With 2026 reserved season tickets nearing a sellout again for the third consecutive season, the $489 Standing Room Only Fan Sports Pass guarantees season-long access into Autzen Stadium, at a discounted price over single game prices. There are no penalties for not attending a game, however you do need to confirm your attendance in order to receive a ticket. You can review your schedule on your homepage.",
  },
  {
    question: "Where are my tickets?",
    answer:
      "You will be notified tickets are available the day before the game and are delivered within your Go Ducks gameday app.",
  },
  {
    question: "How are tickets sent to me? ",
    answer:
      "The day before the game you will receive a text confirming that tickets have been delivered to Go Ducks gameday app.",
  },
  {
    question: "Where will my seats be located?",
    answer:
      "Seats are Standing Room Only with reserved seat upgrades for select game availability.",
  },
  {
    question: "Can these tickets be transferred to a friend?",
    answer:
      "Oregon Football Fan Pass tickets, as well as seat upgrades and guest passes, are not eligible for resale or transfer. Abusing these guidelines can result in your Oregon Football Fan Pass being revoked.",
  },
  {
    question: "Can my seats be changed?",
    answer:
      "Once tickets have been sent to your account, they cannot be changed. Please contact tickets@uoregon.edu for any assistance you may require.",
  },
  {
    question: "Can I link tickets with other pass holders?",
    answer: (
      <>
        You can absolutely create a group to link with other pass holders!
        Navigate to the{" "}
        <Link
          href={{
            pathname: routes.my_group,
            query: { teamSchema: "oregon_fanpass" },
          }}
        >
          My Group
        </Link>{" "}
        tab in your menu and copy the invite. This will ensure you are seated
        next to or close enough to hand a drink to one another for the game. You
        will need to ensure your group is created and all members have joined
        the Thursday prior to the game in order to be seated with one another.
      </>
    ),
  },
  {
    question: "Can I bring a friend to a game?",
    answer:
      "Guest tickets & upgrades may be available for select games. If available, guest tickets are available for purchase when you check into games.",
  },
  {
    question: "Can I receive a refund if I cannot attend a game?",
    answer: "We do not issue any refunds for games you are not able to attend.",
  },
  {
    question: "How can I get a refund and cancel my pass?",
    answer: "An active purchase for the month is not refundable.",
  },
];

export const TERMS_AND_CONDITION = () => (
  <>
    By purchasing you agree to receive SMS alerts regarding ticket delivery and
    agree to the{" "}
    <Link
      target={"_blank"}
      href="https://cdn.prod.website-files.com/66b3d5184e88b53f24e71360/6836259e2aac5657874b9955_Attend%20Terms%20of%20Use%20052425.pdf"
    >
      Terms & Conditions
    </Link>{" "}
    and{" "}
    <Link
      target={"_blank"}
      href="https://cdn.prod.website-files.com/66b3d5184e88b53f24e71360/683625a812daf6ceadcbe532_Attend%20Privacy%20Policy%20052725.pdf"
    >
      Privacy Policy
    </Link>
    .
  </>
);
